import M from 'materialize-css';

class Sidenav
{
    constructor(element, options)
    {
        this.element = element;
        this.options = Object.assign({
            edge: 'right',
        }, options);

        this.initialize();
    }

    initialize()
    {
        M.Sidenav.init(this.element, this.options);
    }
}

export default Sidenav;